import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { queryClient } from '@/lib/react-query';
import exploreStore from '@/features/explore/store/useExploreStore';
import useFetchMessageOutput from '@/features/explore/api/fetchMessageOutput';

export const tableOperation = (data) => {
  return axios.post(`/api/v1/agent/operation`, data);
};

export const useTableOperation = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  const fetchMessageOutput = useFetchMessageOutput();
  return useMutation({
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Something went wrong!',
      });
    },
    onSuccess: async (data, payload) => {
      const operation = payload.operation?.[0] || {};
      const url = window.location.href;
      const operationName = operation.name;
      if (
        data.success &&
        url.includes('deep-dive') &&
        operationName !== 'search'
      ) {
        let queryKey = ['search-messages', payload.conversationId];
        const isLast = exploreStore.getState().searchMessage.isLast;
        if (isLast) {
          queryKey.push('');
        } else {
          queryKey.push(payload.messageId);
        }
        queryClient.setQueryData(queryKey, (queryData) => {
          const message = structuredClone(queryData);
          if (message.messageId === payload.messageId) {
            message.finalOutput = message.finalOutput.map((output) => {
              if (
                output.type === 'table' &&
                payload.stepId === output.stepId &&
                payload.name === output.name
              ) {
                const field = operation.field;
                if (operationName === 'filter') {
                  output.data = data.data;
                  output.count = data.count;
                }
                output.schema = data.schema;
                if (operationName === 'delete') {
                  addNotification({
                    type: 'success',
                    title: `${output.schema[field].label} Successfully Deleted`,
                  });
                }
                if (operationName !== 'pagination') {
                  output.isModified = true;
                }
                const newOperation = {
                  operation: operationName,
                  column: field,
                  ...(operationName === 'reorder' && {
                    newPosition: operation.new_position,
                  }),
                  ...(operationName === 'sort' && {
                    newDirection: operation.type,
                  }),
                  ...(operationName === 'filter' && {
                    newValues:
                      operation.type !== null
                        ? payload.operation[0].values
                        : null,
                  }),
                  ...(operationName === 'rename' && {
                    newName: operation.new_name,
                  }),
                };
                if (Array.isArray(output.operations)) {
                  output.operations = [...output.operations, newOperation];
                } else {
                  output.operations = [newOperation];
                }
              }
              return output;
            });
          }
          return message;
        });
        const isFocused = exploreStore.getState().charts.isFocused;
        if (isFocused) {
          exploreStore.getState().setUpdateFocusedMessage(true);
        }
        if (operationName === 'delete') {
          fetchMessageOutput.mutateAsync({
            metadata: {
              conversationId: payload.conversationId,
              messageId: payload.messageId,
              name: payload.name,
              stepId: payload.stepId,
            },
          });
        }
        if (['filter', 'rename', 'delete'].includes(operationName)) {
          if (isFocused) {
            queryClient.resetQueries([
              'explore-chart-suggestions',
              payload.messageId,
            ]);
          } else {
            queryClient.resetQueries([
              'explore-chart-suggestions',
              payload.messageId,
            ]);
          }
        }
      } else if (!data.success) {
        if (operation === 'delete') {
          addNotification({
            type: 'success',
            title: `Unable to delete ${payload.operation[0].field}`,
          });
        } else {
          addNotification({
            type: 'error',
            title: data?.message || 'Failed to load data',
          });
        }
      }
    },
    ...config,
    mutationFn: tableOperation,
  });
};
